import { render, staticRenderFns } from "./kds.vue?vue&type=template&id=86e7f8e6"
import script from "./kds.vue?vue&type=script&lang=js"
export * from "./kds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86e7f8e6')) {
      api.createRecord('86e7f8e6', component.options)
    } else {
      api.reload('86e7f8e6', component.options)
    }
    module.hot.accept("./kds.vue?vue&type=template&id=86e7f8e6", function () {
      api.rerender('86e7f8e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/kds.vue"
export default component.exports